import './Stakeholder.scss'
import React, {useState} from 'react'
import {useTranslation} from "react-i18next"
import {Button, Col, Form, Icon, Input, message, notification, Row, Spin} from 'antd'
import {createNewUserPromise, forgotPasswordPromise, getLoginPortalDataPromise, registerUserPromise} from './promises'
import {validateEntityRutHelper} from "../../helpers";
import Countdown from '../../layouts/Private/components/Countdown/Countdown'
import i18nextConfig from "../../config/i18next";

const PublicPortal = ({form, countryCode, successHandler, handleLoginRut}) => {
    const {t} = useTranslation(["translations", "forms"]);
    const {getFieldDecorator, validateFields} = form
    const [isCreate, setIsCreate] = useState(false)
    const [isRestore, setIsRestore] = useState(false)
    const [isValidating, setIsValidating] = useState(false);
    const [rut, setRut] = useState(null)
    const [confirmDirty, setConfirmDirty] = useState(false);
    const [captchaResponse, setCaptchaResponse] = useState(null);
    const [captchaSucess, setCaptchaSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // const [captchaKey, setCaptchaKey] = useState(Math.random());

    const renderFormItem = (formItem) => {
        return (
            <Row className={formItem.styleClass}>
                <Form.Item label={formItem.label} hasFeedback={formItem.hasFeedback}>

                    {getFieldDecorator(formItem.name,
                        {
                            rules: formItem.rules,
                            initialValue: formItem.initialValue
                        })
                    (formItem.item)}
                </Form.Item>
            </Row>
        )
    }

    const rutValidate = (rule, value, callback) => {
        if (value && !validateEntityRutHelper(value)) {
            callback(t('portal.title.invalidField', {ns: 'forms'}))
        }
        callback()
    }

    const handleSubmit = async (e) => {
        handleCatpcha(false)
        e.preventDefault()
        setIsLoading(true)

        validateFields(async (err, values) => {
            if (!err) {
                if (isRestore) {
                    forgotPasswordPromise(countryCode, rut)
                        .then(response => {
                            if (response.success) {
                                notification.success({
                                    message: "Correo enviado",
                                    description: "Se envió correo con contraseña temporal"
                                })
                            } else if (response.data.code === '400-10') {
                                notification.error({
                                    message: "Error",
                                    description: "Máximo de intentos alcanzado, inténtelo más tarde."
                                })
                            } else {
                                notification.error({
                                    message: "Error",
                                    description: response.data.status ?? t('messages.aml.notifications.anErrorOcurred')
                                })
                            }
                        })
                        .finally(() => {
                            setIsLoading(false)
                        })
                } else if (isCreate) {
                    createNewUserPromise(countryCode, rut, values.email, values.nombre)
                        .then(response => {
                            notification.success({message: response.data.status, description: t('portal.register.success', {ns: 'forms'})})
                            setIsValidating(true)
                            setIsCreate(false)
                        }).catch(response => {
                            notification.error({message: response?.data?.status, description: t('portal.register.' + response?.data?.message, {ns: 'forms'})})
                        })
                    setIsLoading(false)
                } else if (isValidating) {
                      await registerUserPromise(countryCode, rut, values.verificationCode, values.newPw)
                        .then(response => {
                            if (response.data.status === 201 || response.data.status === 202) { //responseCode -> 202-00
                                notification['success'](
                                    {message: i18nextConfig.t('messages.aml.successfull.portal.register')})
                                setIsValidating(false)
                            }else{
                                const errorMessages = {
                                    "400-10": 'messages.aml.errors.passwordCannotBeInLogin',
                                    "400-20": 'messages.aml.errors.passwordMustHaveBetween8and30Chars',
                                    "400-30": 'messages.aml.errors.passwordMustBeAlphanumeric',
                                    "400-40": 'messages.aml.errors.passwordMustHaveLowerCaseLetter',
                                    "400-50": 'messages.aml.errors.passwordMustHaveUpperCaseLetter',
                                    "400-60": 'messages.aml.errors.youCannotUsePreviousPasswords',
                                    "400-70": 'messages.aml.errors.invalid.current.pwd',
                                    "400-80": 'messages.aml.errors.newPwdIdenticalToCurrent',
                                    "400-00": 'messages.aml.errors.invalid.rut',
                                    "404-00": 'messages.aml.errors.user.not.found',
                                    "409-00": 'messages.aml.errors.user.conflict.user.already.exist',
                                    "401-00": 'messages.aml.errors.incorrect.code',
                                    "403-00": 'messages.aml.errors.expired.code',
                                    "500": 'messages.aml.errors.unknownError'
                                };
                                const validationMessage = errorMessages[response.data.data.code] || 'messages.aml.errors.unknownError';
                                notification['error']({message: i18nextConfig.t(validationMessage)});
                            }
                        }).catch(data => {
                            notification['error']({ message: i18nextConfig.t('messages.aml.errors.unknownError') })
                        }).finally(
                            setIsLoading(false)
                        )
                } else {
                    getLoginPortalDataPromise(countryCode, rut, values.password).then(response => {
                        if (response) {
                            successHandler(response.data.record, response.data.code)
                        } else {
                            notification.error({message: "Error", description: response.data.status})
                        }
                    }).catch(response => {
                        notification.error({
                            message: response.data.status,
                            description: response.data.attempts ? "Quedan" + response.data.attempts + "intentos" : null
                        })
                    }).finally(() => setIsLoading(false))
                }

            } else {
                message.error(t('messages.aml.missingRequiredField'))
                setIsLoading(false)
            }
        });
    }

    const handleUsernameOnChange = (rut) => {
        setRut(rut);
        handleLoginRut(rut)
    }

    const validateToNextPassword = (rule, value, callback) => {
        if (value && confirmDirty) {
            validateFields(['confirmPw'], {force: true});
        }
        callback();
    };

    const compareToFirstPassword = (rule, value, callback) => {
        if (value && value !== form.getFieldValue('newPw')) {
            callback(t('portal.register.message1', {ns: 'forms'}));
        } else {
            callback();
        }
    };

    const handleSwitchToRestore = async (e) => {
        e.preventDefault()
        setIsRestore(true)
        handleCatpcha(false)
    }

    const handleConfirmBlur = (e) => {
        const {value} = e.target;
        setConfirmDirty(confirmDirty || !!value);
    };

    const handleSwitchToCreate = async (e) => {
        e.preventDefault()
        setIsCreate(true)
        setIsRestore(false)
        setIsValidating(false)
        handleCatpcha(false)
    }

    const handleSwitchToLogin = async (e) => {
        e.preventDefault()
        setIsRestore(false)
        setIsCreate(false)
        setIsValidating(false)
        handleCatpcha(false)
    }

    const handleCatpcha = async (success, response) => {
        setCaptchaSuccess(success);
        if (response) {
            setCaptchaResponse(response);
        } else {
            setCaptchaResponse(null);
            setCaptchaSuccess(false);
        }
    }

    const isLoginView = !isRestore && !isCreate && !isValidating

    return (

        <div className="stakeholder-public">
            <div className="login">
                <div className="login-content">
                    <Row>
                        <Col xs={24} className="login-container">
                            <Form onSubmit={handleSubmit} className="login-form">
                            <div className={isLoginView ? 'portal-auth-cards' : undefined}>
                            <div className="login-box">
                                {isLoading && <Spin/>}
                                    <Row>
                                        <Col xs={24}>
                                            {isRestore ?
                                                <h2>{t('messages.aml.restorePassword')}</h2>
                                                :
                                                (isCreate ? <h2>{t('messages.aml.register')}</h2>
                                                        : isValidating ? <h2>{t('portal.title.verifyEmail', {ns: 'forms'})}</h2> :
                                                            (
                                                                <h2 className="title">
                                                                    <span>{t('messages.aml.sessionStart','Iniciar sesión')} <br/> {t('messages.aml.usersPortal')}</span>
                                                                </h2>
                                                            )
                                                )
                                            }
                                        </Col>
                                    </Row>
                                    {!isValidating &&
                                        <Row>
                                            <Col xs={24}>
                                                {
                                                    renderFormItem({
                                                        label: t('messages.aml.portal.username'),
                                                        styleClass: "crud-label",
                                                        initialValue: rut,
                                                        name: 'rutForm',
                                                        rules: [
                                                            {required: true, message: t('portal.title.rutRequired', {ns: 'forms'})}
                                                        ],
                                                        item: (
                                                            <Input
                                                                autocomplete="nope"
                                                                allowClear
                                                                onChange={(e) => handleUsernameOnChange(e.target.value)}
                                                                prefix={<Icon type="user"
                                                                              style={{color: 'rgba(0,0,0,.2)'}}/>}
                                                                placeholder={t('messages.aml.rutNumber')}
                                                            />
                                                        )
                                                    })
                                                }
                                            </Col>
                                        </Row>
                                    }

                                    {isCreate &&
                                        <Row>
                                            <Col xs={24}>
                                                {
                                                    renderFormItem({
                                                        label: t('messages.aml.email'),
                                                        styleClass: "crud-label",
                                                        name: 'email',
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: t('portal.title.mailRequired', {ns: 'forms'})
                                                            },
                                                            {
                                                                type: 'email',
                                                                message: t('portal.title.invalidField', {ns: 'forms'})
                                                            }
                                                        ],
                                                        item: (
                                                            <Input
                                                                autocomplete="off"
                                                                prefix={<Icon type="mail"
                                                                              style={{color: 'rgba(0,0,0,.2)'}}/>}
                                                                placeholder={t("messages.aml.email")}
                                                            />
                                                        )
                                                    })
                                                }
                                                <span className="portal-label-hint" style={{display: 'block', marginTop: -5, textAlign: 'left'}}>
                                                    {t('messages.aml.portal.emailHint')}
                                                </span>
                                            </Col>
                                        </Row>
                                    }

                                    {isValidating &&
                                        <Row>
                                            <Col xs={24}>
                                                {
                                                    renderFormItem({
                                                        label: t('portal.title.sentCode', {ns: 'forms'}),
                                                        hasFeedback: true,
                                                        styleClass: "crud-label",
                                                        name: 'verificationCode',
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: t('messages.aml.requestedField')
                                                            },
                                                            {
                                                                len: 8,
                                                                message: t('portal.title.codeRules', {ns: 'forms'})
                                                            }
                                                        ],
                                                        item: (
                                                            <Input
                                                                autocomplete="off"
                                                                prefix={<Icon type="key"
                                                                              style={{color: 'rgba(0,0,0,.2)'}}/>}
                                                                placeholder={t('portal.title.enterCode', {ns: 'forms'})}
                                                            />
                                                        )
                                                    })
                                                }
                                            </Col>
                                            <Col xs={24}>
                                                {
                                                    renderFormItem({
                                                        label: t('messages.aml.newPassword'),
                                                        hasFeedback: true,
                                                        styleClass: "crud-label",
                                                        name: 'newPw',
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: t('messages.aml.requestedField')
                                                            },
                                                            {
                                                                validator: (_, value) => {
                                                                    if (value && (value.length < 8 || value.length > 30)) {
                                                                        return Promise.reject(new Error(t('messages.aml.errors.pwd.long.validation')));
                                                                    }
                                                                    return Promise.resolve();
                                                                }
                                                            },
                                                            {
                                                                validator: (_, value) => {
                                                                    const allowedChars = /^[a-zA-Z0-9&*?@#!$%\-_]+$/;
                                                                    const hasUppercase = /[A-Z]/;
                                                                    const hasLowercase = /[a-z]/;
                                                                    const hasLetter = /[a-zA-Z]/;
                                                                    const hasDigit = /[0-9]/;

                                                                    if (!value) {
                                                                        return Promise.resolve();
                                                                    }

                                                                    if (!hasUppercase.test(value)) {
                                                                        return Promise.reject(new Error(t('messages.aml.validation.passwordMustHaveUpperCaseLetter')));
                                                                    }

                                                                    if (!hasLowercase.test(value)) {
                                                                        return Promise.reject(new Error(t('messages.aml.validation.passwordMustHaveLowerCaseLetter')));
                                                                    }

                                                                    if (!hasDigit.test(value)  || !hasLetter.test(value)) {
                                                                        return Promise.reject(new Error(t('messages.aml.validation.password.must.be.alphanum')));
                                                                    }

                                                                    if (!allowedChars.test(value)) {
                                                                        return Promise.reject(new Error(t('messages.aml.errors.pwd.special.characters')));
                                                                    }

                                                                    return Promise.resolve();
                                                                }
                                                            },
                                                            {
                                                                validator: validateToNextPassword
                                                            },
                                                        ],
                                                        item: (
                                                            <Input.Password
                                                                autocomplete="off"
                                                                prefix={<Icon type="lock"
                                                                              style={{color: 'rgba(0,0,0,.2)'}}/>}
                                                                placeholder={t('messages.aml.enterPassword')}
                                                            />
                                                        )
                                                    })
                                                }
                                            </Col>
                                            <Col xs={24}>
                                                {
                                                    renderFormItem({
                                                        label: t('messages.aml.repeatNewPassword'),
                                                        hasFeedback: true,
                                                        styleClass: "crud-label",
                                                        name: 'confirmPw',
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: t('messages.aml.requestedField')
                                                            },
                                                            {
                                                                validator: (_, value) => {
                                                                    if (value && (value.length < 8 || value.length > 30)) {
                                                                        return Promise.reject(new Error(t('messages.aml.errors.pwd.long.validation')));
                                                                    }
                                                                    return Promise.resolve();
                                                                }
                                                            },
                                                            {
                                                                validator: (_, value) => {
                                                                    const allowedChars = /^[a-zA-Z0-9&*?@#!$%\-_]+$/;
                                                                    const hasUppercase = /[A-Z]/;
                                                                    const hasLowercase = /[a-z]/;
                                                                    const hasLetter = /[a-zA-Z]/;
                                                                    const hasDigit = /[0-9]/;

                                                                    if (!value) {
                                                                        return Promise.resolve();
                                                                    }

                                                                    if (!hasUppercase.test(value)) {
                                                                        return Promise.reject(new Error(t('messages.aml.validation.passwordMustHaveUpperCaseLetter')));
                                                                    }

                                                                    if (!hasLowercase.test(value)) {
                                                                        return Promise.reject(new Error(t('messages.aml.validation.passwordMustHaveLowerCaseLetter')));
                                                                    }

                                                                    if (!hasDigit.test(value)  || !hasLetter.test(value)) {
                                                                        return Promise.reject(new Error(t('messages.aml.validation.password.must.be.alphanum')));
                                                                    }
                                                                    if (!allowedChars.test(value)) {
                                                                        return Promise.reject(new Error(t('messages.aml.errors.pwd.special.characters')));
                                                                    }

                                                                    return Promise.resolve();
                                                                }
                                                            },
                                                            {
                                                                validator: compareToFirstPassword
                                                            }
                                                        ],
                                                        item: (
                                                            <Input.Password
                                                                onBlur={handleConfirmBlur}
                                                                autocomplete="off"
                                                                prefix={<Icon type="lock"
                                                                              style={{color: 'rgba(0,0,0,.2)'}}/>}
                                                                placeholder={t('messages.aml.repeatNewPassword')}
                                                            />
                                                        )
                                                    })
                                                }
                                            </Col>
                                        </Row>
                                    }

                                    {!isRestore && !isCreate && !isValidating &&
                                        <Row>
                                            <Col xs={24}>
                                                {
                                                    renderFormItem({
                                                        label:  t('messages.aml.password'),
                                                        styleClass: "crud-label",
                                                        name: 'password',
                                                        rules: [{
                                                            required: true,
                                                            message: t('messages.aml.dontForgetPassword')
                                                        }],
                                                        item: (
                                                            <Input.Password
                                                                // onChange={(e) => handlePasswordOnChange(e.target.value)}
                                                                autocomplete="off"
                                                                prefix={<Icon type="lock"
                                                                              style={{color: 'rgba(0,0,0,.2)'}}/>}
                                                                placeholder={t('messages.aml.password')}
                                                            />
                                                        )
                                                    })
                                                }
                                            </Col>
                                        </Row>
                                    }
                                    {(true || captchaSucess || (!isRestore && !isCreate)) &&
                                        <Row>
                                            <Col xs={24}>
                                                <Button
                                                    className="login-form-button-portal"
                                                    type="primary"
                                                    htmlType="submit"
                                                    disabled={rut === null || rut === undefined || rut === '' || isLoading}
                                                    icon={isLoading && "loading"}
                                                >
                                                    {isRestore ? t('messages.aml.send') : isCreate ? t('portal.title.next', {ns: 'forms'}) : isValidating ? t('portal.title.register', {ns: 'forms'}) : t('messages.aml.sessionStart')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    }
                                    {isRestore ?
                                        <Row className="login-description">
                                            <Col xs={24}>
                                                {t('messages.aml.newPassword.will.send.to')}
                                            </Col>
                                        </Row>
                                        : isCreate ?
                                            <Row className="login-description">
                                                <Col xs={24}>
                                                    {t('messages.aml.code.will.send')}
                                                </Col>
                                            </Row>
                                            : isValidating ?
                                                <div>
                                                    <Row className="login-description">
                                                        <Col xs={24}>
                                                            <p>{t('messages.aml.newPasswordMustContain')}: <br/><strong>{t('messages.aml.newPasswordInstructions')}</strong>
                                                            </p></Col>
                                                    </Row>
                                                    <Row className="login-description">
                                                        <Col xs={24}>
                                                            {t('messages.aml.code.validation.send')}
                                                            <br/>
                                                            {t('messages.aml.code.will.expire')} <Countdown
                                                            startingMinutes={15} startingSeconds={0}/>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                :
                                                <Row>
                                                </Row>
                                    }
                                    {isLoginView &&
                                        <Row className="forgot-container">
                                            <Button type="link" onClick={handleSwitchToRestore}> {t('messages.aml.forgotYourPassword')} </Button>
                                        </Row>
                                    }
                                    {(isRestore || isCreate) &&
                                        <Button type="link" className="login-link-portal" onClick={handleSwitchToLogin}
                                                style={{
                                                    display: 'block',
                                                    textAlign: 'center',
                                                    paddingTop: 15
                                                }}>{t('messages.aml.backToLogin')}</Button>
                                    }
                            </div>
                            {isLoginView &&
                                <div className="login-box portal-register-card">
                                    <h2 className="title">
                                        <span>{t('messages.aml.firstTimeUsing')}<br/>{t('messages.aml.theUsersPortal')}</span>
                                    </h2>
                                    <Button
                                        className="login-form-button-portal"
                                        type="primary"
                                        htmlType="button"
                                        onClick={handleSwitchToCreate}
                                    >
                                        {t('messages.aml.registerHere')}
                                    </Button>
                                </div>
                            }
                            </div>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

const StakeForm = Form.create({name: 'login_form'})(PublicPortal)
export default StakeForm
